import React, { FC } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Typography } from 'antd';
import constants from '~/utils/constants';
import styled from 'styled-components';
import theme from '~/theme';

const PrivacyPolicyFooter: FC = () => {
  const { t } = useTranslation('translation');
  return (
    <Container>
      <div>
        <Trans i18nKey="Read our <1>Terms and Conditions</1> and <3>Privacy Policy</3>">
          {'Read our '}
          <a target="_blank" rel="noopener noreferrer" href={constants?.termsAndConditionsURL ?? ''}>
            Terms and Conditions
          </a>
          {' and '}
          <a target="_blank" rel="noopener noreferrer" href={constants?.privacyPolicyURL ?? ''}>
            Privacy Policy
          </a>
        </Trans>
      </div>
      <Typography.Paragraph>
        {!!constants?.copyrightText && `© ${t('by')} ${constants?.copyrightText}`}
      </Typography.Paragraph>
    </Container>
  );
};

const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;

  div {
    color: ${theme.disabledColor};
  }
`;

export default PrivacyPolicyFooter;
